<template>
  <v-app-bar app color="white" elevate-on-scroll>
    <v-app-bar-nav-icon @click="changeDrawerVisibility"></v-app-bar-nav-icon>
    <v-toolbar-title></v-toolbar-title>

    <v-spacer></v-spacer>

    <v-menu offset-y rounded="lg" bottom right transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon x-large v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar color="grey" size="48">
              <img :src="userPictureUrl" alt="User" />
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Admin</v-list-item-title>
            <v-list-item-subtitle>admin@tmshelper.tiesi.it</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider> </v-divider>

        <v-list-item @click.stop="onLogout" link disabled>
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Impostazioni</v-list-item-title>
        </v-list-item>

        <v-list-item @click.stop="onLogout" link disabled>
          <v-list-item-icon>
            <v-icon>mdi-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Profilo</v-list-item-title>
        </v-list-item>

        <v-divider> </v-divider>

        <v-list-item @click.stop="onLogout" link>
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
// Store
import { mapActions } from 'vuex'

// Component
export default {
  name: 'TheAdminAppBar',
  components: {},

  data: () => ({
    drawer: true,
    mini: true,
  }),

  computed: {
    userPictureUrl() {
      return require(`@/assets/img/user-picture-1.webp`)
    },
  },

  methods: {
    ...mapActions('layout', ['changeDrawerVisibility']),
    ...mapActions('auth', ['logout']),
    async onLogout() {
      await this.logout()
      await this.$router.push('/')
    },
  },
}
</script>
